import { TableCell } from "@/components/ui";

const CustomTableCell = ({
  children,
  className,
}: {
  children?: React.ReactNode;
  className?: string;
}) => <TableCell className={`${className ?? ""}`}>{children}</TableCell>;

export default CustomTableCell;
